import { useController } from 'react-hook-form'

import { DoorMultiSelect } from '../../door-multi-select'
import { TextField, ToggleField } from '../../legacy-form-fields'
import { ButterflyConnectionFormValues } from './butterfly.schema'
import { useButterflyConnection } from './use-butterfly-connection'

interface ButterflyFieldsProps {
  buildingId: number
  disabled: boolean
  isConfigured: boolean
}

export const ButterflyFields = ({ buildingId, disabled, isConfigured }: ButterflyFieldsProps) => {
  // Note: same query key as the useConnection call in IntegrationCard — cache hit, not a
  // second request. See keyless-integrations.registry.ts / Salto Space for this pattern.
  const { doors, isLoadingDoors } = useButterflyConnection(buildingId)

  const authorizationCode = useController<ButterflyConnectionFormValues, 'authorizationCode'>({
    name: 'authorizationCode',
  })
  const autoAssignToggle = useController<
    ButterflyConnectionFormValues,
    'shouldAutoAssignApartmentDoorVisitor'
  >({
    name: 'shouldAutoAssignApartmentDoorVisitor',
  })
  const visitorDoors = useController<ButterflyConnectionFormValues, 'visitorPermissionDoors'>({
    name: 'visitorPermissionDoors',
  })

  return (
    <div className="integration-configuration">
      <TextField
        errorLabel={authorizationCode.fieldState.error?.message}
        isError={Boolean(authorizationCode.fieldState.error)}
        label="Authorization Code"
        name={authorizationCode.field.name}
        placeholder="Paste the code obtained from ButterflyMX"
        value={authorizationCode.field.value ?? ''}
        onBlur={authorizationCode.field.onBlur}
        onChange={authorizationCode.field.onChange}
      />
      <p className="integration-configuration__hint">
        Get this code by following ButterflyMX&apos;s OAuth authorization steps (see the team wiki)
        — a new code is required every time this form is submitted, including updates.
      </p>

      <ToggleField
        id="shouldAutoAssignApartmentDoorVisitor"
        label="Autoassign Visitor's apartment door access"
        name={autoAssignToggle.field.name}
        value={autoAssignToggle.field.value}
        onChange={autoAssignToggle.field.onChange}
      />

      <div className="access-container">
        <h3 className="access-title">Visitor default doors</h3>
        <DoorMultiSelect
          disabled={disabled}
          isConfigured={isConfigured}
          isLoading={isLoadingDoors}
          options={doors}
          placeholder="Select doors..."
          value={visitorDoors.field.value ?? []}
          onChange={visitorDoors.field.onChange}
        />
      </div>
    </div>
  )
}
